<template>
	<!-- Presentational source bar (spec §2): owns no selection state, hosts wire
	     the emits to the launcher / their goal add-remove handlers. Read-only and
	     view modes must not render this bar at all. -->
	<div class="flex flex-wrap items-center gap-2">
		<span class="flex items-center gap-1 text-sm shrink-0">
			<PlusIcon class="w-4 h-4" />
			{{ $t('Add from') }}...
		</span>

		<GoalSelectorCurriculumButton
			:scope="scope"
			:pending="launchPending"
			@openCurriculum="$emit('openCurriculum', $event)"
			@clickLearnMore="showCurriculumInfo = true"
		/>

		<GoalSelectorCollectionsDropdown
			:scope="scope"
			@openCollection="$emit('openCollection', $event)"
			@clickLearnMore="showGradeLevelCollectionInfo = true"
		/>

		<GoalSelectorThemesDropdown
			v-if="context === 'agendaLessonPlan'"
			:weekGoals="weekGoals"
			:selectedGoals="selectedGoals"
			@goalSelected="$emit('goalSelected', $event)"
			@goalUnselected="$emit('goalUnselected', $event)"
			@clickLearnMore="showWeekGoalsInfo = true"
		/>

		<KBView v-if="showCurriculumInfo" :url="{
			en: 'https://handsomely-cicada-2cb.notion.site/ebd/21f0964c114280e79774d872429f6149',
			nl: 'https://handsomely-cicada-2cb.notion.site/ebd/2770964c114280f6a0d6e9d572f3a1f4',
		}" @requestClose="showCurriculumInfo = false" />

		<KBView v-if="showGradeLevelCollectionInfo" :url="{
			en: 'https://handsomely-cicada-2cb.notion.site/ebd/26c0964c114280f19c27f43a9ffd12a3',
			nl: 'https://handsomely-cicada-2cb.notion.site/ebd//26c0964c1142803d8742c64fc362c907',
		}" @requestClose="showGradeLevelCollectionInfo = false" />

		<KBView v-if="showWeekGoalsInfo" :url="{
			en: '',
			nl: '',
		}" @requestClose="showWeekGoalsInfo = false" />
	</div>
</template>

<script lang="ts">
import { PlusIcon } from "@heroicons/vue/24/outline";
import GoalSelectorCurriculumButton from "@/components/GoalSelectorCurriculumButton.vue";
import GoalSelectorCollectionsDropdown from "@/components/GoalSelectorCollectionsDropdown.vue";
import GoalSelectorThemesDropdown from "@/components/GoalSelectorThemesDropdown.vue";
import KBView from "@/components/KBView.vue";

export default {
	emits: ['openCurriculum', 'openCollection', 'goalSelected', 'goalUnselected'],

	components: {
		PlusIcon,
		GoalSelectorCurriculumButton,
		GoalSelectorCollectionsDropdown,
		GoalSelectorThemesDropdown,
		KBView,
	},

	props: {
		context: {
			type: String,
			required: true,
			validator: (value: string) => ['lessonPlan', 'themeWeek', 'agendaLessonPlan'].includes(value),
		},

		// Selection scope — see GoalSelectorCurriculumButton. In 'school' scope the
		// collections dropdown also filters to the current classroom's assigned
		// collections; curriculum-wise the collections and themes dropdowns are
		// deliberately NOT scoped (spec decision 2026-07-29).
		scope: {
			type: String,
			required: true,
			validator: (value: string) => ['global', 'school'].includes(value),
		},

		selectedGoals: {
			type: Array,
			default: () => [],
		},

		weekGoals: {
			type: Array,
			default: () => [],
		},

		// Pure pass-through: the bar owns no launch state, the host does.
		launchPending: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			showCurriculumInfo: false,
			showGradeLevelCollectionInfo: false,
			showWeekGoalsInfo: false,
		};
	},
};
</script>
